import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react";
import { createElement } from "react";
import type { FieldUiOptions } from "./types";

import { SectionNodeView } from "./views/section-node-view";

/**
 * ParagraphSection node — simple paragraph content for descriptions.
 *
 * Allows one or more paragraphs of plain text with inline formatting.
 * Used for entity descriptions across all entity types.
 */
export const ParagraphSection = Node.create({
  name: "paragraphSection",
  content: "paragraph+",
  defining: true,
  isolating: true,

  addOptions() {
    return {
      HTMLAttributes: {} as Record<string, unknown>,
      fieldUiOptions: {} as FieldUiOptions,
    };
  },

  addAttributes() {
    return {
      fieldId: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-field-id") ?? "",
        renderHTML: (attributes) => ({ "data-field-id": attributes.fieldId }),
      },
      label: {
        default: "Description",
        parseHTML: (element) => element.getAttribute("data-label") ?? "Description",
        renderHTML: (attributes) => ({ "data-label": attributes.label }),
      },
      guidance: { default: "", rendered: false },
      chromeless: { default: false, rendered: false },
      ownerId: { default: null, rendered: false },
      _diffStatus: { default: null, rendered: false },
      _diffOldValue: { default: null, rendered: false },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="paragraph-section"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": "paragraph-section",
      }),
      0,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer((props) =>
      createElement(SectionNodeView, {
        ...props,
        fieldUiOptions: this.options.fieldUiOptions,
      })
    );
  },
});
